/**
 * 共通ユーティリティ.
 */
module.exports = {
  /**
   * 正規表現.
   */
  regex: {
    numerical: /^[0-9]+$/,
    numerical_and_double: /^[0-9０-９]+$/,
    numerical_minus: /^[-]?[0-9]+$/,
    decimal: /^[0-9]+(\.[0-9]+)?$/,
    decimal_minus: /^[-]?[0-9]+(\.[0-9]+)?$/,
    // wareki: /^.{2}\d{1,2}年\d{2}月\d{2}日$/,
    // time_long: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/
    time: /^([01][0-9]|2[0-3]):([0-5][0-9])$/,
    post_no: /^[0-9]{3,10}$/,
    post_no_3_7: /^[0-9]{3,7}$/,
    tel: /^[0-9-]+$/,
    phone: /^\d{1,4}-?\d{1,4}-?\d{1,4}$/,
    email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    hiragana: /^[\u3040-\u309f\u0020\u00a0\u3000\u30fb\u30fc]+$/ // ひらがな 半角空白 全角空白 中点・ 長音符ー
  },
  /**
   * キーコード
   */
  keycode: {
    tab: 9, // TAB
    enter: 13, // エンター
    shift: 16, // SHIFT
    page_up: 33, // PageUp
    page_down: 34, // PageDown
    arrow_up: 38, // 上キー
    arrow_down: 40 // 下キー
  },
  /**
   * 入力 ディレイ(ミリ秒)
   */
  key_delay: 500,
  /**
   * 全ての文字列を置き換える.
   * @param expression 文字列
   * @param org 検索文字列
   * @param dest 置き換え文字列
   * @returns {string}
   */
  replaceAll: function (expression, org, dest) {
    return ('' + expression).split(org).join(dest)
  },
  /**
   * 空白確認.
   * @param val 値
   * @param isTrim 空白を除外して評価 ※省略可 デフォルト空白除去評価しない
   * @return boolean
   */
  isBlank: function (val, isTrim) {
    // デフォルト
    if (typeof isTrim === 'undefined') {
      isTrim = false // 空白除去評価
    }

    if (typeof val === 'undefined' || val === null || val === '') {
      return true
    }
    if (isTrim && ('' + val).trim() === '') {
      return true
    }
    return false
  },
  /**
   * 空白以外確認.
   * @param val 値
   * @param isTrim 空白を除外して評価 ※省略可 デフォルト空白除去評価しない
   * @return boolean
   */
  isPresent: function (val, isTrim) {
    return !this.isBlank(val, isTrim)
  },
  isType: function (type, obj) {
    var clas = Object.prototype.toString.call(obj).slice(8, -1)
    return obj !== undefined && obj !== null && clas === type
  },
  /**
   * 数値確認.
   * @param val
   * @param isMinus マイナス符号も評価
   * @return boolean
   */
  isNumerical: function (val, isMinus) {
    if (this.isBlank(isMinus)) {
      isMinus = false
    }
    if (isMinus) {
      return this.regex.numerical_minus.test(('' + val))
    } else {
      return this.regex.numerical.test(('' + val))
    }
  },
  /**
   * 数値確認（全角数字も可）.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isNumericalDouble: function (val, isBlankPass) {
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    if (this.isBlank(val)) {
      return isBlankPass
    }
    return this.regex.numerical_and_double.test(('' + val))
  },
  /**
   * 全角数値を半角に変換.
   * @param val
   * @param isErrorVal 変換出来ない時に返す値 デフォルトnull
   * @return boolean
   */
  double2HalfNumerical: function (val, isErrorVal) {
    if (this.isBlank(isErrorVal)) {
      isErrorVal = null
    }
    if (this.isBlank(val)) {
      return isErrorVal
    }
    if (!this.isNumericalDouble(val)) {
      return isErrorVal
    }
    var num = ('' + val).replace(/[０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    })
    return this.str2int(num)
  },
  /**
   * 小数値含む確認.
   * @param val
   * @param isMinus マイナス符号も評価
   * @return boolean
   */
  isDecimal: function (val, isMinus) {
    if (this.isBlank(isMinus)) {
      isMinus = false
    }
    if (isMinus) {
      return this.regex.decimal_minus.test(('' + val))
    } else {
      return this.regex.decimal.test(('' + val))
    }
  },
  /**
   * 配列確認
   * @param item 確認対象
   * @returns boolean
   */
  isArray: function (item) {
    return Object.prototype.toString.call(item) === '[object Array]'
  },
  /**
   * オブジェクト確認
   * @param item 確認対象
   * @returns boolean
   */
  isObject: function (item) {
    return typeof item === 'object' && item !== null && !this.isArray(item)
  },
  /**
   * 安全にオブジェクトから値を取得します
   * @param arr data['key1']['key2']['key3']
   * @param keys ['key1', 'key2', 'key3']
   * @param notFoundVal 見つからない場合に返す値
   * @returns {*}
   */
  getSafeArrVal: function (arr, keys, notFoundVal) {
    var result = arr
    for (var i = 0; i < keys.length; i++) {
      if (!(keys[i] in result)) {
        return notFoundVal
      }
      if (result[keys[i]] === null) {
        return notFoundVal
      }
      result = result[keys[i]]
    }
    return result
  },
  /**
   * 配列から目的のキーオブジェクト値を返します.
   * @param arr [{'key1': 'val1'}, {'key2': 'val2'}, {'key3' : 'val3'}] 形式
   * @param key 見つけるキー
   * @param notFoundVal 見つからない場合に返す値 ※省略可能
   * @returns {*}
   */
  getArrKeyVal: function (arr, key, notFoundVal) {
    if (this.isBlank(notFoundVal)) {
      notFoundVal = null
    }
    var result = notFoundVal
    for (var i = 0; i < arr.length; i++) {
      if (key in arr[i]) {
        result = arr[i][key]
        break
      }
    }
    return result
  },
  /**
   * オブジェクトをソート
   * @param ary
   * @param key
   * @param order
   * @returns {*}
   */
  objArraySort: function (ary, key, order) {
    var reverse = 1
    if (order && order.toLowerCase() === 'desc') {
      reverse = -1
    }
    ary.sort(function (a, b) {
      if (a[key] < b[key]) {
        return -1 * reverse
      } else if (a[key] === b[key]) {
        return 0
      } else {
        return 1 * reverse
      }
    })
    return ary
  },
  /**
   * key val 形式に対して先頭にデータを追加します。
   *  例：[{key:'1', val:'a'}, {key:'2', val:'a'}]
   *  例：[{key:'', val:'ー'}, {key:'1', val:'a'}, {key:'2', val:'a'}]
   * @param arr
   * @param key 省略可 省略時 空文字
   * @param val 省略可 省略時 ハイフン
   * @returns {Array}
   */
  setAddKeyValOrHyphen: function (arr, key, val) {
    if (this.isBlank(key)) {
      key = ''
    }
    if (this.isBlank(val)) {
      val = '-'
    }
    arr.unshift({key: key, val: val})
    return arr
  },
  /**
   * selectボックスデータを取得します.
   * @param arr 左記形式 [{'key':'1', 'val':'data1'},{'key':'2', 'val':'data2'}]
   * @param isAddHyphen ハイフンを先頭に付与します
   * @returns {Array}
   */
  getSelectArr: function (arr, isAddHyphen) {
    var result = []
    if (isAddHyphen) {
      result = this.setAddKeyValOrHyphen(arr)
    }
    for (var i = 0; i < arr.length; i++) {
      result.push({key: arr[i][0], val: arr[i][1]})
    }
    return result
  },
  /**
   * オブジェクト同士の比較
   * @param obj1
   * @param obj2
   * @returns boolean true:違いがある / false:違いがない
   */
  checkObjDiff: function (obj1, obj2) {
    return !this.isEq(obj1, obj2)
  },
  /**
   * オブジェクト／配列が持つ各値が同じか確認
   * @param obj1 比較元
   * @param obj2 比較先
   * @returns boolean true:同じ / false:同じでない
   */
  isEq: function (obj1, obj2) {
    if (this.isArray(obj1) && this.isArray(obj2)) {
      return obj1.every(function (elem, index, array) {
        return this.isEq(obj1[index], obj2[index])
      }, this)
    }
    if (this.isObject(obj1) && this.isObject(obj2)) {
      return Object.keys(obj1).every(function (key) {
        return this.isEq(obj1[key], obj2[key])
      }, this)
    }
    return (obj1 === obj2) || (this.isBlank(obj1) && this.isBlank(obj2))
  },
  /**
   * オブジェクト／配列のコピーを返す
   * @param obj クローン元
   * @returns {}
   */
  clone: function (obj) {
    let r = {}
    for (var key in obj) {
      if (this.isArray(obj[key])) {
        r[key] = [].concat(obj[key])  // shallow copy
        continue
      }
      if (this.isObject(obj[key])) {
        r[key] = this.clone(obj[key]) // deep copy
        continue
      }
      r[key] = obj[key]
    }
    return r
  },
  /**
   * 日付型を文字列に変換.
   * @param date 指定日文字列 省略可能
   * @param format フォーマット 省略可能
   *               y     : '2000'
   *               y-m   : '2000-01'
   *               y-m-d : '2000-01-01' ※省略時デフォルト
   *               ym    : '200001'
   *               ymd   : '20000101'
   */
  getDate2Str: function (date, format) {
    if (this.isBlank(format)) {
      format = 'y-m-d'
    }
    var result = null
    if (format === 'y') {
      result = date.getFullYear()
    } else if (format === 'y-m') {
      result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
    } else if (format === 'y-m-d') {
      result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
    } else if (format === 'ym') {
      result = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2)
    } else if (format === 'ymd') {
      result = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2)
    }
    return result
  },
  /**
   * 日付加算をします.
   * @param date date型
   * @param cat 'y':年 'm':月 'd':日 何れか指定
   * @param add 加算数
   * @returns {*}
   */
  dateAddCalc: function (date, cat, add) {
    var result = null
    if (cat === 'd') {
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (add * 1))
    } else if (cat === 'm') {
      result = new Date(date.getFullYear(), date.getMonth() + (add * 1), date.getDate())
    } else if (cat === 'y') {
      result = new Date(date.getFullYear() + (add * 1), date.getMonth(), date.getDate())
    }
    return result
  },
  /**
   * 西暦→和暦 変換.
   * @param $t (this.$t) を渡す
   * @return String
   */
  sereki2Wareki: function ($t, date) {
    var warekiConf = $t('wareki')
    var strYear = $t('ymd.year')
    var strMonth = $t('ymd.month')
    var strDay = $t('ymd.day')

    if (this.isBlank(date)) {
      return null // NG
    }
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var yyyymmdd = this.getDate2Str(date, 'ymd')
    var gg = null
    var gengou = ''

    for (var i = 0; i < warekiConf.length; i++) {
      var strDate = parseInt(warekiConf[i]['str_date'], 10)
      if (yyyymmdd >= strDate) {
        gengou = warekiConf[i]['gengou']
        gg = year - parseInt(('' + strDate).substring(0, 4), 10) + 1
        break
      }
    }

    if (this.isBlank(gg)) {
      return null // NG
    }

    gg = ('0' + gg).slice(-2)
    month = ('0' + month).slice(-2)
    day = ('0' + day).slice(-2)

    return gengou + gg + strYear + month + strMonth + day + strDay
  },
  /**
   * 和暦→西暦 変換 ※Date型 または 指定フォーマットを返す.
   * @param $t (this.$t) を渡す
   * @param strWareki 和暦(平成01年01月01日)
   * @param format フォーマット 省略可能
   *               Date型:              ※省略時デフォルト
   *               y     : '2000'
   *               y-m   : '2000-01'
   *               y-m-d : '2000-01-01'
   *               ym    : '200001'
   *               ymd   : '20000101'
   * @return Date|String
   */
  wareki2Seireki: function ($t, strWareki, format) {
    var warekiConf = $t('wareki')
    var strYear = $t('ymd.year')
    var strMonth = $t('ymd.month')
    var strDay = $t('ymd.day')

    // 空白
    if (this.isBlank(strWareki)) {
      return null
    }

    // 正規表現チェック
    var reg = new RegExp('^.{2}\\d{1,2}' + strYear + '\\d{1,2}' + strMonth + '\\d{1,2}' + strDay + '$')
    if (!reg.test(strWareki)) {
      return null // NG
    }

    // 元号 年月日 取得
    var year = strWareki.substring(0, strWareki.indexOf(strYear))
    var gengou = year.substring(0, 2)
    var gg = year.substring(2, year.length)
    var mm = strWareki.substring(strWareki.indexOf(strYear) + 1, strWareki.indexOf(strMonth))
    var dd = strWareki.substring(strWareki.indexOf(strMonth) + 1, strWareki.indexOf(strDay))

    // 数値チェック
    if (!this.isNumerical(gg) || !this.isNumerical(mm) || !this.isNumerical(dd)) {
      return null // NG
    }

    // 数値変換
    gg = parseInt(gg, 10)
    mm = parseInt(mm, 10) - 1
    dd = parseInt(dd, 10)

    // i18nと合致する元号を検索
    var yyyyPlus = null
    var strDate = null
    var endDate = null
    for (var i = 0; i < warekiConf.length; i++) {
      if (gengou === warekiConf[i]['gengou']) {
        // 元号が一致
        var gengouEnd = parseInt(warekiConf[i]['gengou_end'], 10)
        if (gg <= gengouEnd) {
          yyyyPlus = parseInt(warekiConf[i]['str_date'].substring(0, 4), 10)
          strDate = parseInt(warekiConf[i]['str_date'], 10)
          endDate = parseInt(warekiConf[i]['end_date'], 10)
        }
        break
      }
    }
    if (this.isBlank(yyyyPlus)) {
      return null // NG
    }

    // 元号 + 元号開始日
    var yyyy = yyyyPlus + (gg - 1)

    // 元号範囲外
    var yyyymmdd = parseInt('' + yyyy + ('0' + (mm + 1)).slice(-2) + ('0' + dd).slice(-2), 10)
    if (strDate > yyyymmdd || endDate < yyyymmdd) {
      return null // NG
    }

    // 日付チェク
    if (yyyy >= 0 && mm >= 0 && mm <= 11 && dd >= 1 && dd <= 31) {
      var date = new Date(yyyy, mm, dd)
      if (isNaN(date)) {
        return null // NG
      } else if (date.getFullYear() === yyyy && date.getMonth() === mm && date.getDate() === dd) {
        // OK
        if (this.isBlank(format)) {
          // フォーマット指定なし
          return date // OK Date形式
        }
        // フォーマット指定あり
        return this.getDate2Str(date, format) // OK String形式
      }
    }
    return null // NG
  },
  /**
   * 和暦チェック.
   * @param $t (this.$t) を渡す
   * @param strWareki 和暦(H9-01-01)
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isWareki: function ($t, strWareki, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(strWareki)) {
      return isBlankPass
    }

    // パース
    var wareki = this.wareki2Seireki($t, strWareki)
    if (wareki !== null) {
      return true // OK
    }
    return false // NG
  },
  /**
   * 時間チェック.
   * @param strTime
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isTime: function (strTime, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(strTime)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.time.test(strTime)) {
      return true // OK
    }

    return false // NG
  },
  /**
   * 電話番号チェック.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isPhone: function (val, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(val)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.phone.test(val)) {
      return true // OK
    }
    if (this.regex.numerical.test(('' + val))) {
      return true // OK
    }

    return false // NG
  },
  /**
   * メールアドレスチェック.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isEmail: function (val, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(val)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.email.test(val)) {
      return true // OK
    }

    return false // NG
  },
  /**
   * ひらがなチェック.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isHiragana: function (val, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(val)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.hiragana.test(val)) {
      return true // OK
    }
    return false // NG
  },
  /**
   * 郵便番号チェック.
   * @param val
   * @param isBlankPass 空白時にOKとするか ※省略可 デフォルト空白OK
   * @return boolean
   */
  isPostNo: function (val, isBlankPass) {
    // デフォルト
    if (this.isBlank(isBlankPass)) {
      isBlankPass = true
    }
    // 空白
    if (this.isBlank(val)) {
      return isBlankPass
    }

    // 正規表現チェック
    if (this.regex.post_no_3_7.test(val)) {
      return true // OK
    }

    return false // NG
  },
  /**
   * ユーザーエージェントがスマホか確認.
   * @return boolean
   */
  isSmartPhone: function () {
    var ua = navigator.userAgent
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      return true
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      return true
    }
    return false
  },
  /**
   * 改行カウントオーバーを判定します.
   * @param text 文字列
   * @param setting 閾値 以下の形式
   *   {
   *     lineFeed:      改行上限
   *     lenMax:        １行の最大文字数（超えた場合は１改行と見なす）
   *     isOneLineCalc: １行のみの場合 文字数 / lenMaxでの改行制限計算を行うか ※省略時はfalse
   *     ajast:         isOneLineCalc = true を指定した場合の調整行
   *   }
   * @return 真偽
   */
  isLineFeedCountOver: function (text, setting) {
    if (this.isBlank(text)) {
      return false // ok
    }
    var isOneLineCalc = false
    if ('isOneLineCalc' in setting) {
      isOneLineCalc = setting.isOneLineCalc
    }
    var ajast = 0
    if ('ajast' in setting) {
      ajast = setting.ajast
    }

    var lineFeedCount = 0
    var charCount = 0
    var str = ('' + text).replace(/\r\n|\r/g, '\n')
    var lfArr = str.match(/\n/g)
    if (lfArr === null) {
      // 改行なし
      lineFeedCount = 0
      // １行のみの場合に文字数計算を行うか
      if (isOneLineCalc) {
        charCount = this.charCount(str)
        if (charCount > setting.lenMax && setting.lenMax > 0) {
          lineFeedCount = Math.floor(charCount / setting.lenMax)
          if (lineFeedCount > ajast) {
            lineFeedCount -= ajast
          }
        }
      }
    } else {
      // 改行あり
      lineFeedCount = lfArr.length
      var lines = str.split('\n')
      for (var i = 0; i < lines.length; i++) {
        charCount = this.charCount(lines[i])
        if (charCount > setting.lenMax && setting.lenMax > 0) {
          lineFeedCount += Math.floor(charCount / setting.lenMax)
        }
      }
    }
    // 改行数が超えたか確認
    if (lineFeedCount > setting.lineFeed) {
      return true // ng
    }
    return false // ok
  },
  /**
   * 文字数をカウント
   * @param str 文字列
   * @returns {number}
   */
  charCount: function (str) {
    if (this.isBlank(str)) {
      return 0
    }
    var len = 0
    str = escape(('' + str))
    for (var i = 0; i < str.length; i++, len++) {
      if (str.charAt(i) === '%') {
        if (str.charAt(++i) === 'u') {
          i += 3
          len++
        }
        i++
      }
    }
    return len
  },
  /**
   * 文字列を数字に変換.
   * @param val 文字列 または 数字でも可
   * @param missDefault 失敗時のデフォルト値 ※省略可 デフォルトnull
   */
  str2int: function (val, missDefault) {
    if (this.isBlank(missDefault)) {
      missDefault = null
    }
    var result = missDefault
    if (this.isPresent(val)) {
      if (this.isNumerical(val)) {
        result = parseInt(val, 10)
      }
    }
    return result
  },
  /**
   * idからテキストを取得します.
   * @param group
   * @param id
   * @returns {string}
   */
  id2text: function (group, id) {
    for (let i in group) {
      if (group[i].id + '' === id + '') {
        return group[i].text
      }
    }
    return ''
  },
  /**
   * ビット値から配列を取得します.
   * @param value
   * @param bitArray
   */
  bitvalue2group: function (value, bitArray) {
    var group = []
    if (value === null || value === undefined) {
      value = 0
    }
    for (var i in bitArray) {
      if ((value & bitArray[i].id) > 0) {
        group.push(bitArray[i].id)
      }
    }
    return group
  },
  /**
   * 配列からビット値を取得します.
   * @param group
   * @returns {number}
   */
  group2bitvalue: function (group) {
    let bitvalue = 0
    for (let i in group) {
      if (group[i] !== null) {
        bitvalue = bitvalue | group[i]
      }
    }

    return bitvalue
  },
  /**
   * 配列からid配列を取得します.
   * @param group
   * @returns {Array}
   */
  group2ids: function (group) {
    let ids = []
    for (let item in group) {
      if (group[item] in group) {
        ids.push(group[item].id)
      }
    }
    return ids
  },
  /**
   * 最下部スクロールイベント.
   * ※注意： '更に読み込む' ボタン等に 'next-page-search-btn' クラスを付与してください.
   */
  scrollBottomSearchEvent: function (callback, callbackParam, nextPageElem) {
    var block = true
    var body = null
    var commonAjaxLoading = null
    // イベント削除
    this.scrollBottomSearchEventRemove()
    // ロード
    var didRender = function () {
      body = document.getElementsByTagName('body')[0]
      commonAjaxLoading = document.getElementById('commonAjaxLoading')
    }
    // スクロール
    var onScroll = function () {
      if (body === null || body === undefined || commonAjaxLoading === null || commonAjaxLoading === undefined) {
        didRender()
      } else {
        // 最下部に達した場合
        var target = /BackCompat/i.test(document.compatMode) ? document.body : document.documentElement
        var scrollTop = window.pageYOffset || target.scrollTop
        if (target.scrollHeight - scrollTop === target.clientHeight) {
          // 更に読み込むボタンがある場合
          if (document.querySelectorAll(nextPageElem).length > 0) {
            if (block) {
              block = false
              if (commonAjaxLoading.style['display'] === 'none') {
                callback(callbackParam)
              }
            }
          }
        } else {
          if (commonAjaxLoading.style['display'] === 'none') {
            block = true
          }
        }
      }
    }
    window.scrollBottomSearchDidRender = function () { didRender() }
    window.scrollBottomSearchOnScroll = function () { onScroll() }
    window.addEventListener('load', window.scrollBottomSearchDidRender, false)
    window.addEventListener('scroll', window.scrollBottomSearchOnScroll, false)
  },
  /**
   * 最下部スクロールイベント削除.
   */
  scrollBottomSearchEventRemove: function () {
    if (window.scrollBottomSearchDidRender) {
      window.removeEventListener('load', window.scrollBottomSearchDidRender, false)
    }
    if (window.scrollBottomSearchOnScroll) {
      window.removeEventListener('scroll', window.scrollBottomSearchOnScroll, false)
    }
  },
  /**
   * スクロールの高さを取得します.
   */
  getScrollHeight: function () {
    return document.documentElement.scrollHeight || document.body.scrollHeight
  },
  /**
   * スクロールの高さ監視し、目的のスクロールを設定します.
   * @param saveScrollHeight
   * @param pageYOffset
   * @returns {MutationObserver}
   */
  setScrollHeight: function (saveScrollHeight, pageYOffset) {
    if (this.isBlank(saveScrollHeight) || this.isBlank(pageYOffset)) {
      return null
    }
    var h = this.getScrollHeight()
    if (h >= saveScrollHeight) {
      window.scrollTo(0, pageYOffset)
      return null
    }

    var self = this
    var count = 0
    var callback = function () {
      var h = self.getScrollHeight()
      if (h >= saveScrollHeight) {
        window.scrollTo(0, pageYOffset)
        result.disconnect()
        return
      }
      count++
      if (count > 10) {
        window.scrollTo(0, pageYOffset)
        result.disconnect()
        return
      }
      setTimeout(function () {
        callback()
      }, 100)
    }
    // 要素の監視
    var result = new MutationObserver(callback)
    result.observe(document.body, {childList: true, attributes: true, subtree: true})
    return result
  },
  /**
   * オートコンプリートイベント.
   * @param opt 以下の通り
   * {
   *  $:                  $,
   *  elem:               要素ID,
   *  search:             検索メソッド,
   *  searchParams:       検索メソッド引数 false,
   *  searchAutocomplete: オートコンプリート検索メソッド,
   *  setSearchData:      オートコンプリート設定メソッド,
   *  clear:              オートコンプリートクリアメソッド ※省略可,
   * }
   */
  autocompleteEvent: function (opt) {
    var $ = opt['$']
    var elem = opt['elem']
    var search = opt['search']
    var searchParams = opt['searchParams']
    var searchAutocomplete = opt['searchAutocomplete']
    var setSearchData = opt['setSearchData']
    var clear = null
    var self = this
    var stack = []
    var userAgent = window.navigator.userAgent.toLowerCase()
    var isIe = false
    var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'
    if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {
      isIe = true
    }
    var isFireFox = false
    if (userAgent.indexOf('firefox') >= 0) {
      isFireFox = true
    }
    var isSmartPhone = this.isSmartPhone()

    if ('clear' in opt) {
      clear = opt['clear']
    }

    // フォーカスアウトから遅れてajax処理が戻ってきた場合の処理
    if (clear !== null) {
      // 要素検索
      var elemSearch = function (elem, count, mutation) {
        if ($(elem).length > 0) {
          mutation()
        } else {
          setTimeout(() => {
            if (count < 30) {
              count++
              elemSearch(elem, count, mutation)
            }
          }, 500)
        }
      }
      // 監視
      var mutation = function () {
        var callback = function () {
          var $focused = $(':focus')
          if (isIe) {
            $('ul.options-list > li').width($('ul.options-list').width())
            $('ul.options-list > li > span').width($('ul.options-list').width())
          }
          $('ul.options-list').off('click.autocomplete')
          $('ul.options-list').off(mousewheelevent + '.autocomplete')
          if (self.isPresent($focused.attr('id'))) {
            if ('#' + $focused.attr('id') === elem) {
              // 選択時に元の要素へフォーカス移動
              $('ul.options-list').on('click.autocomplete', 'li > span', function (e) {
                $(elem).addClass('manual-focus')
                $(elem).focus()
              })
              // スクロールが親に伝播しないよう制御
              $('ul.options-list').on(mousewheelevent + '.autocomplete', function (e) {
                var height = $(this).height()
                var scrollHeight = $(this).get(0).scrollHeight
                var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail)
                if ((this.scrollTop >= Math.ceil(scrollHeight - height) && delta < 0) || (this.scrollTop === 0 && delta > 0)) {
                  e.preventDefault()
                }
              })
              return
            }
          }
          var $ul = $(elem).next('ul.options-list')
          if ($ul.length > 0) {
            setTimeout(function () {
              clear()
            }, 100)
          }
        }
        var $parent = $(elem).parent()
        if (self.isBlank(window.MutationObserverList)) {
          window.MutationObserverList = []
        }
        // 子要素の監視
        window.MutationObserverList.push(new MutationObserver(callback))
        window.MutationObserverList[window.MutationObserverList.length - 1].observe($parent[0], {childList: true, attributes: true, subtree: true})
      }

      $(elem).ready(function () {
        if ($(elem).length > 0) {
          mutation()
        } else {
          elemSearch(elem, 0, mutation)
        }
      })
    }

    if (isFireFox || isSmartPhone) {
      // IME確定時
      $(document).off('compositionend.autocomplete', elem)
      $(document).on('compositionend.autocomplete', elem, function (e) {
        stack = []
        searchAutocomplete()
      })
    }

    // フォーカス
    $(elem).removeClass('manual-focus')
    $(document).off('focus.autocomplete', elem)
    $(document).on('focus.autocomplete', elem, function (e) {
      if ($(elem).hasClass('manual-focus')) {
        $(elem).removeClass('manual-focus')
      } else {
        searchAutocomplete()
      }
    })
    // フォーカスアウト
    $(document).off('blur.autocomplete', elem)
    $(document).on('blur.autocomplete', elem, function (e) {
      $(elem).removeClass('manual-focus')
    })

    // キーボード押下
    $(document).off('keydown.autocomplete', elem)
    $(document).on('keydown.autocomplete', elem, function (e) {
      var c = e.which ? e.which : e.keyCode
      var $ul = $(this).next('ul.options-list')
      var top, sc, pos, activeHeight

      if (c === self.keycode.enter) {
        // エンターキー
        if ($ul.children('li.active').length > 0) {
          var $span = $ul.children('li.active').children('span')
          $ul.children('li').removeClass('active')
          setSearchData($span.data('id'), $span.data('name'))
        } else {
          search(searchParams)
        }
      } else if (c === self.keycode.arrow_up) {
        // 上キー
        if ($ul.children('li').length > 0) {
          e.preventDefault()
          if ($ul.children('li.active').length <= 0) {
            // 未選択
            // $ul.children('li:last').addClass('active')
            $ul.children('li:first').addClass('active')
            $ul.scrollTop(0)
          } else if ($ul.children('li:first.active').length > 0) {
            // 最上位
            // 何もしない
          } else {
            // 現在より上を色付け
            $ul.children('li.active').removeClass('active').prev('li').addClass('active')
            // スクロール
            activeHeight = $ul.offset().top + $ul.height() - $ul.children('li.active').height() - $ul.children('li.active').offset().top
            if ($ul.offset().top >= $ul.children('li.active').offset().top || activeHeight < 0) {
              top = $ul.children('li.active').position().top
              sc = $ul.scrollTop()
              pos = top + sc
              if (pos < 0) {
                pos = 0
              }
              $ul.scrollTop(pos)
            }
          }
        }
      } else if (c === self.keycode.arrow_down) {
        // 下キー
        if ($ul.children('li').length > 0) {
          e.preventDefault()
          if ($ul.children('li.active').length <= 0) {
            // 未選択
            $ul.children('li:first').addClass('active')
            $ul.scrollTop(0)
          } else if ($ul.children('li:last.active').length > 0) {
            // 最下位
            // 何もしない
          } else {
            // 現在より下を色付け
            $ul.children('li.active').removeClass('active').next('li').addClass('active')
            // スクロール
            activeHeight = $ul.offset().top + $ul.height() - $ul.children('li.active').height()
            if (activeHeight <= $ul.children('li.active').offset().top || activeHeight - $ul.children('li.active').offset().top >= $ul.height()) {
              top = $ul.children('li.active').position().top + $ul.children('li.active').outerHeight(true)
              sc = $ul.scrollTop()
              pos = top + sc - $ul.height()
              if (pos < 0) {
                pos = 0
              }
              $ul.scrollTop(pos)
            }
          }
        }
      } else if (c === self.keycode.page_up || c === self.keycode.page_down) {
        // 制御しない
      } else if (
        c === self.keycode.tab ||
        (e.shiftKey && c === self.keycode.tab) ||
        c === self.keycode.page_up ||
        c === self.keycode.page_down
      ) {
        stack = []
      } else {
        $ul.children('li').removeClass('active')
        // それ以外 キー押下毎に発生する大量Ajax防止
        stack.push(1)
        setTimeout(function () {
          if (stack.length > 0) {
            stack.pop()
            if (stack.length === 0) {
              stack = []
              searchAutocomplete()
            }
          }
        }, self.key_delay)
      }
    })
  },
  /**
   * オートコンプリートイベント.
   * @param opt 以下の通り
   * {
   *  $:    $,
   *  elem: 要素ID,
   * }
   */
  autocompleteEventRemove: function (opt) {
    var $ = opt['$']
    var elem = opt['elem']
    var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'
    // 監視を停止
    $(document).off('click.autocomplete', 'body')
    if (this.isPresent(window.MutationObserverList)) {
      if (window.MutationObserverList.length > 0) {
        for (var i = 0; i < window.MutationObserverList.length; i++) {
          window.MutationObserverList[i].disconnect()
          window.MutationObserverList[i] = null
        }
      }
      window.MutationObserverList = null
    }
    // イベント削除
    $(document).off('focus.autocomplete', elem)
    $(document).off('blur.autocomplete', elem)
    $(document).off('compositionend.autocomplete', elem)
    $(document).off('keydown.autocomplete', elem)
    $('ul.options-list').off('click.autocomplete')
    $('ul.options-list').off(mousewheelevent + '.autocomplete')
  },
  /**
   * スティッキーイベント スマートフォン版
   * @param opt
   * {
   *   blockId:      幅を取得するためのブロック要素
   *   targetId:     スティッキー対象
   *   addCls:       fixedを付与するCSSクラス
   *   headerCls:    ヘッダーの余白を求めるため、ヘッダー要素クラスを指定 ※PC用
   * }
   */
  stickyEventSmartPhone: function (opt) {
    var block = null
    var target = null
    var didRender = null
    var onResize = null
    var onScroll = null

    didRender = function () {
      // ロード
      block = document.getElementById(opt.blockId)
      target = document.getElementById(opt.targetId)
      onResize()
    }
    onResize = function () {
      // リサイズ
      if (block === null || block === undefined || target === null || target === undefined) {
        didRender()
        return
      }
      var { paddingLeft, paddingRight } = window.getComputedStyle(target.parentNode)
      var parentWidth = target.parentNode.offsetWidth - parseInt(paddingLeft) - parseInt(paddingRight)
      target.style.width = `${parentWidth}px`
      target.className += ' ' + opt.addCls
    }
    onScroll = function () {
      // スクロール
      if (block === null || block === undefined || target === null || target === undefined) {
        didRender()
        return
      }
      if (target.className.indexOf(opt.addCls) < 0) {
        onResize()
      }
    }

    window.stickyEventDidRender = function () { didRender() }
    window.stickyEventOnResize = function () { onResize() }
    window.stickyEventOnScroll = function () { onScroll() }

    window.addEventListener('load', window.stickyEventDidRender, false)
    window.addEventListener('resize', window.stickyEventOnResize, false)
    window.addEventListener('scroll', window.stickyEventOnScroll, false)
  },
  /**
   * スティッキーイベント PC版
   * ※今後、CSSの position: sticky; がサポートされた場合はこの処理は不要となります。
   * @param opt
   * {
   *   blockId:      幅を取得するためのブロック要素
   *   targetId:     スティッキー対象
   *   addCls:       fixedを付与するCSSクラス
   *   headerCls:    ヘッダーの余白を求めるため、ヘッダー要素クラスを指定
   * }
   */
  stickyEventPc: function (opt) {
    var block = null
    var target = null
    var didRender = null
    var onResize = null
    var onScroll = null
    var removedScrollClass = null
    var targetForm = null
    var targetFormMarginTop = 0

    // 大きい値を取得
    var mathMax = function (a, b) {
      if (a > b) {
        return a
      }
      return b
    }

    didRender = function () {
      // ロード
      block = document.getElementById(opt.blockId)
      target = document.getElementById(opt.targetId)
      targetForm = document.getElementsByClassName(opt.targetForm)[0]
      if (target && targetForm) {
        removedScrollClass = target.className
        targetFormMarginTop = targetForm.style.marginTop
      }
      onResize()
    }
    onResize = function () {
      // リサイズ
      if (
        block === null || block === undefined ||
        target === null || target === undefined ||
        targetForm === null || targetForm === undefined
      ) {
        didRender()
      }
      targetForm = document.getElementsByClassName(opt.targetForm)[0]
      var { paddingLeft, paddingRight } = window.getComputedStyle(target.parentNode)
      var parentWidth = target.parentNode.offsetWidth - parseInt(paddingLeft) - parseInt(paddingRight)
      target.style.width = `${parentWidth}px`
      var headerHeight = document.getElementsByClassName(opt.headerCls)[0].clientHeight + 1
      target.style.top = `${headerHeight}px`
      targetFormMarginTop = targetForm.style.marginTop
      targetForm.style.marginTop = `${targetFormMarginTop}px`
    }
    onScroll = function () {
      // スクロール
      if (
        block === null || block === undefined ||
        target === null || target === undefined ||
        targetForm === null || targetForm === undefined
      ) {
        didRender()
      }
      var scroll = mathMax(document.documentElement.scrollTop, document.body.scrollTop)
      // var topOffset = block.offsetTop
      var topOffset = 1
      targetForm = document.getElementsByClassName(opt.targetForm)[0]
      if (target.className.indexOf(opt.addCls) > -1) {
        if (scroll <= topOffset) {
          target.className = removedScrollClass
          targetForm.style.marginTop = 0
        }
      } else if (scroll >= topOffset) {
        target.className += ' ' + opt.addCls
        var h = target.offsetHeight
        targetForm.style.marginTop = `${h}px`
      }
    }

    window.stickyEventDidRender = function () { didRender() }
    window.stickyEventOnResize = function () { onResize() }
    window.stickyEventOnScroll = function () { onScroll() }

    window.addEventListener('load', window.stickyEventDidRender, false)
    window.addEventListener('resize', window.stickyEventOnResize, false)
    window.addEventListener('scroll', window.stickyEventOnScroll, false)
  },

  /**
   * スティッキーイベント削除.
   */
  stickyEventRemove: function () {
    if (window.stickyEventDidRender) {
      window.removeEventListener('load', window.stickyEventDidRender, false)
    }
    if (window.stickyEventOnResize) {
      window.removeEventListener('resize', window.stickyEventOnResize, false)
    }
    if (window.stickyEventOnScroll) {
      window.removeEventListener('scroll', window.stickyEventOnScroll, false)
    }
  },
  /**
   * JS動的読み込み.
   * ※ window.addEventListener 'load' イベント後に実装しないと正常動作しません.
   * @param opt 以下の形式
   * {
   *   js: JS定義ファイル,
   *   key: google app key等クエリーストリングに含める値
   * }
   */
  loadScript: function (opt, callback) {
    // 既に存在しないか検索
    var prefixSrc = opt.js.split('/')[0]
    var existScript = document.getElementsByTagName('script')
    var exist = false
    Array.prototype.map.apply(existScript, [function (s) {
      if (s.src.indexOf(prefixSrc) > 0) {
        exist = true
      }
    }])

    if (exist) {
      // 既にJSを読み込んでいる
      callback()
    } else {
      // JS読み込み
      var src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + opt.js
      if ('key' in opt) {
        if (src.indexOf('?') < 0) {
          src += '?key=' + opt.key
        } else {
          src += '&key=' + opt.key
        }
      }
      var done = false
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.src = src
      head.appendChild(script)
      script.onload = script.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          done = true
          callback()
          script.onload = script.onreadystatechange = null
          if (head && script.parentNode) {
            head.removeChild(script)
          }
        }
      }
    }
  },
  /**
   * Google Map.
   * @param opt 以下の形式
   * {
   *   js:          コンストのJS定義ファイル,
   *   key:         コンストの Google App Key,
   *   mapElmId:    マップ要素ID,
   *   lat:         緯度初期値,   ※省略時やnullは map_defaultの値
   *   lng:         経度初期値,   ※省略時やnullは map_defaultの値
   *   zoom:        ズーム,       ※省略時やnullは map_defaultの値
   *   map_default:    constant.map_defaultを設定
   *   mapCallback:    コールバック,
   *   logoChange:     ロゴを変更するか否か ※デフォルト変更する
   *   logoLinkChange: ロゴのリンクを変更するか否か ※デフォルト変更する
   * }
   */
  googleMapEvent: function (opt) {
    var self = this
    var loadScript = this.loadScript
    var lat = opt.lat
    var lng = opt.lng
    var zoom = opt.zoom
    var mapCallback = opt.mapCallback
    var initMarka = true
    var logoChange = true
    var logoLinkChange = true

    if (this.isDecimal(lat)) {
      lat = parseFloat(lat)
    } else {
      lat = opt.map_default.lat
      initMarka = false
    }
    if (this.isDecimal(lng)) {
      lng = parseFloat(lng)
    } else {
      lng = opt.map_default.lng
      initMarka = false
    }
    if (this.isNumerical(zoom)) {
      zoom = parseInt(zoom, 10)
    } else {
      zoom = opt.map_default.zoom
      initMarka = false
    }
    // ロゴを変更するか否か
    if ('logoChange' in opt) {
      logoChange = opt.logoChange
    }
    // ロゴのリンクを変更するか否か
    if ('logoLinkChange' in opt) {
      logoLinkChange = opt.logoLinkChange
    }

    // イベント 削除
    this.googleMapEventRemove()

    /** 表示処理. */
    var didRender = function () {
      // JS読み込み
      loadScript(opt, function () {
        // 要素検索
        var map = self.googleElemSearch(opt.mapElmId, 0)
        if (map === null) {
          return
        }

        // 初期位置
        var googleMap = new google.maps.Map(map, {
          zoom: zoom,
          center: {
            lat: lat,
            lng: lng
          }
        })

        // 初期マーカー
        var marker = null
        if (initMarka) {
          marker = new google.maps.Marker({
            position: googleMap.getCenter(),
            map: googleMap
          })
        }
        // クリックイベント
        window.googleMapsEventClick = google.maps.event.addListener(googleMap, 'click', function (e) {
          var loc = e.latLng
          lat = loc.lat()
          lng = loc.lng()
          zoom = googleMap.getZoom()
          // マーカーを設置
          if (marker === null) {
            marker = new google.maps.Marker({
              position: {lat: lat, lng: lng},
              map: googleMap
            })
          }
          marker.setPosition(loc)
          mapCallback(lat, lng, googleMap.getZoom())

          // googleロゴリンク変更
          if (logoLinkChange) {
            self.googleLogoLinkeChange(map, lat, lng, 0)
          }
        })
        // ズームイベント
        window.googleMapsEventZoomChanged = google.maps.event.addListener(googleMap, 'zoom_changed', function () {
          mapCallback(lat, lng, googleMap.getZoom())
        })
        // マーカー削除イベント
        window.googleMapsEventClear = function () {
          if (marker !== null) {
            marker.setMap(null)
            marker = null
          }
        }
        // 住所検索
        window.googleMapsQuerySearch = function (address) {
          var geocoder = new google.maps.Geocoder()
          // 郵便番号や住所の文字列から座標を取得する
          geocoder.geocode({'address': address, 'region': 'jp'},
            function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                var loc = results[0].geometry.location
                lat = loc.lat()
                lng = loc.lng()
                zoom = googleMap.getZoom()

                // 座標へ移動
                googleMap.panTo(new google.maps.LatLng(lat, lng))

                // マーカーを設置
                if (marker === null) {
                  marker = new google.maps.Marker({
                    position: {lat: lat, lng: lng},
                    map: googleMap
                  })
                }
                marker.setPosition(loc)

                // コールバック
                mapCallback(lat, lng, googleMap.getZoom())

                // googleロゴリンク変更
                if (logoLinkChange) {
                  self.googleLogoLinkeChange(map, lat, lng, 0)
                }
              }
            }
          )
        }

        // googleロゴ差し替え
        if (logoChange) {
          self.googleLogoChange(map, 0)
        }

        // googleロゴリンク変更
        if (logoLinkChange && initMarka) {
          self.googleLogoLinkeChange(map, lat, lng, 0)
        }
      })
    }

    // 表示
    didRender()
  },
  /**
   * google map マーカー削除.
   */
  googleMapEventMarkaClear: function () {
    if (window.googleMapsEventClear) {
      window.googleMapsEventClear()
    }
  },
  /**
   * Google Map マーカーのみ.
   * @param opt 以下の形式
   * {
   *   js:          コンストのJS定義ファイル,
   *   key:         コンストの Google App Key,
   *   mapElmId:    マップ要素ID,
   *   map_default: constant.map_defaultを設定
   *   markaList: [
   *      {
   *        lat:     緯度,
   *        lng:     経度,
   *        zoom:    ズーム,
   *        address: 省略可,
   *        title:   省略可,
   *        icon:    省略可
   *      },
   *   ]
   *   scrollwheel:    スクロールで倍率を変更するか否か
   *   logoChange:     ロゴを変更するか否か ※デフォルト変更する
   *   logoLinkChange: googleロゴリンクを変更するか否か ※デフォルト変更する
   *   showMarkerInfo: マーカークリック時に情報ウィンドウを表示するか否か ※デフォルト表示しない
   * }
   */
  googleMapMarkaOnlyEvent: function (opt) {
    var self = this
    var loadScript = this.loadScript
    var lat = opt.map_default.lat
    var lng = opt.map_default.lng
    var zoom = opt.map_default.zoom
    var markaList = opt.markaList
    var markerOption = []
    var googleMapsMarker = []
    var scrollwheel = false
    var logoChange = true
    var logoLinkChange = true
    var showMarkerInfo = false

    // ロゴを変更するか否か
    if ('logoChange' in opt) {
      logoChange = opt.logoChange
    }
    // googleロゴリンクを変更するか否か
    if ('logoLinkChange' in opt) {
      logoLinkChange = opt.logoLinkChange
    }
    // マーカークリック時に情報ウィンドウを表示するか否か
    if ('showMarkerInfo' in opt) {
      showMarkerInfo = opt.showMarkerInfo
    }

    // マーカー
    if (markaList !== null && markaList.length > 0) {
      for (var i = 0; i < markaList.length; i++) {
        if (this.isDecimal(markaList[i].lat) && this.isDecimal(markaList[i].lng) && this.isNumerical(markaList[i].zoom)) {
          // 位置情報
          var option = {
            map: '',
            position: {
              lat: parseFloat(markaList[i].lat),
              lng: parseFloat(markaList[i].lng)
            },
            zoom: parseInt(markaList[i].zoom, 10)
          }
          // 住所
          if ('address' in markaList[i] && this.isPresent(markaList[i].address)) {
            option.address = markaList[i].address
          }
          // タイトル
          if ('title' in markaList[i] && this.isPresent(markaList[i].title)) {
            option.title = markaList[i].title
          }
          // アイコン
          if ('icon' in markaList[i] && this.isPresent(markaList[i].icon)) {
            option.icon = markaList[i].icon
          }
          // マーカーオプション
          markerOption.push(option)
        }
      }
    }
    // スクロール倍率
    if ('scrollwheel' in opt) {
      scrollwheel = opt.scrollwheel
    }

    // イベント 削除
    this.googleMapEventRemove()

    /** 表示処理. */
    var didRender = function () {
      // JS読み込み
      loadScript(opt, function () {
        // 要素検索
        var map = self.googleElemSearch(opt.mapElmId, 0)
        if (map === null) {
          return
        }

        // 1件の場合
        if (markerOption.length === 1) {
          lat = markerOption[0].position.lat
          lng = markerOption[0].position.lng
          zoom = markerOption[0].zoom
        }

        // 初期表示
        var googleMap = new google.maps.Map(map, {
          zoom: zoom,
          center: {
            lat: lat,
            lng: lng
          },
          scrollwheel: scrollwheel
        })

        // 複数件の場合、中心点と倍率をAPIで算出
        if (markerOption.length > 1) {
          var fitBounds = new google.maps.LatLngBounds()
          for (var n = 0; n < markerOption.length; n++) {
            fitBounds.extend(new google.maps.LatLng({
              lat: markerOption[n].position.lat,
              lng: markerOption[n].position.lng
            }))
          }
          googleMap.fitBounds(fitBounds)
        }

        // マーカー
        if (markerOption.length > 0) {
          markerOption.forEach(function (val, index, arr) {
            val.map = googleMap
            var marker = new google.maps.Marker(val)

            // マーカークリックイベント追加
            if (showMarkerInfo) {
              google.maps.event.addListener(marker, 'click', function (event) {
                new google.maps.InfoWindow({
                  content: '<b>' + marker.title + '</b><hr style="margin: 0">' + marker.address
                }).open(marker.getMap(), marker)
              })
            }

            googleMapsMarker.push(marker)
          })
        }

        // googleロゴ差し替え
        if (logoChange) {
          self.googleLogoChange(map, 0)
        }

        // googleロゴリンク変更
        if (logoLinkChange && markerOption.length > 0) {
          self.googleLogoLinkeChange(map, markerOption[0].position.lat, markerOption[0].position.lng, 0)
        }
      })
    }

    // 表示
    didRender()
  },
  /**
   * google map 要素検索.
   */
  googleElemSearch: function (mapElmId, count) {
    var self = this
    var map = document.getElementById(mapElmId)
    if (map) {
      return map
    } else {
      setTimeout(() => {
        if (count < 20) {
          count++
          self.googleElemSearch(mapElmId, count)
        }
      }, 500)
    }
  },
  /**
   * google map ロゴ変更.
   */
  googleLogoChange: function (map, count) {
    var self = this
    var logo = map.querySelector('div.gm-style a img')
    if (logo) {
      logo.src = './static/images/google.png'
      // 差し替えられたか確認
      setTimeout(() => {
        if (logo.src.indexOf('/static/images/google.png') < 0) {
          count++
          self.googleLogoChange(map, count)
        }
      }, 500)
    } else {
      setTimeout(() => {
        if (count < 20) {
          count++
          self.googleLogoChange(map, count)
        }
      }, 500)
    }
  },
  /**
   * google map リンク変更.
   */
  googleLogoLinkeChange: function (map, lat, lng, count) {
    var self = this
    var anchor = map.querySelector('div.gm-style a')
    if (anchor) {
      var link = 'https://maps.google.com/maps?z=12&t=m&q=loc:' + lat + '+' + lng
      anchor.href = link
      // 差し替えられたか確認
      setTimeout(() => {
        if (anchor.href.indexOf(link) < 0) {
          count++
          self.googleLogoLinkeChange(map, lat, lng, count)
        }
      }, 500)
    } else {
      setTimeout(() => {
        if (count < 20) {
          count++
          self.googleLogoLinkeChange(map, lat, lng, count)
        }
      }, 500)
    }
  },
  /**
   * google map イベント削除.
   */
  googleMapEventRemove: function () {
    if (window.googleMapsEventClick) {
      google.maps.event.removeListener(window.googleMapsEventClick)
    }
    if (window.googleMapsEventZoomChanged) {
      google.maps.event.removeListener(window.googleMapsEventZoomChanged)
    }
    if (window.googleMapsEventClear) {
      window.googleMapsEventClear = null
    }
    if (window.googleMapsQuerySearch) {
      window.googleMapsQuerySearch = null
    }
  },
  /**
   * ヘルプモーダル発火
   */
  helpModalShow: function () {
    document.getElementById('help-modal-btn').style['display'] = 'block'
  }
}



// WEBPACK FOOTER //
// ./src/utils.js